"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_STREAM_TYPE = exports.PERMISSIONS = void 0;
exports.PERMISSIONS = {
    STREAM_VIDEO: "produceVideo",
    STREAM_AUDIO: "produceAudio",
    CHANGE_PEER_SCOPE: "changePeerScope",
};
exports.CUSTOM_STREAM_TYPE = "custom";
//# sourceMappingURL=common.js.map